/** 网络、接口 相关配置 **/
export const config = {
  // common
  restServicePath: "/rest/service",

  // 搜索栏
  apiV1Path: "/api/v1",
  websiteAssociationalSearchPath: "/website/associational/search/v2", // 相关热搜
  websiteSearchSolrTender: "/website/solr/tender", // 搜索列表

  restServiceHomepageRealTimeTenderPath: "/service/homepage/realTimeTender", // 实时标讯-标讯、拟在建项目、审批项目
  restCommonHomepageSpecialZonePath: "/common/homepage/specialZone", // 实时标讯-行业
  restCommonHomepageBottomBannerPath: "/common/homepage/bottomBanner", // 获取底部横幅信息 底部信息
  restCommonHomepageSubWebsitePath: "/common/homepage/subWebsite", // 千里马分站
  restCommonHomepageIndustryNavigationPath: "/common/homepage/industryNavigation", // 行业导航
  restBuryPointUserBehaviorAppointmentCallBackPath: "/burypoint/user/behavior/appointmentCallBack", // 预约回电
  restCommonHomepageSendVerificationCodePath: "user/api/homepage/getCode", //发送验证码
  restUApiMemberHomeSendSmsPath: "rest/u/api/member/home/send/sms", //登录发送短信接口
  restUApiMemberHomeSendSmsSlidingPath: "rest/u/api/member/home/send/sms/sliding", //登录发送短信接口(滑块)
  restCommonHomepageLoginOrRegisterPath: "user/api/homepage/registerOrLogin", //登录/注册
  restUserApiHomepageLogoutPath: "/user/logout", //退出登录
  restUApiUserNewWebLoginPath: "/rest/u/api/user/new/web/login", // 账号密码登录接口
  restUApiUserPhoneLoginPath: "/rest/u/api/user/phone/login", // 账号密码登录接口
  restUCompanyGetCompanyInfoPath: "/rest/u/company/getCompanyInfo", // 获取用户信息
  commonCusApiHomepageIdTypeGwPath: "/common/cus/api/homepage/idTypeGw", // 定制版会员中心入口显示
  restUApiMemberHomeGetUsersPath: "rest/u/api/member/home/getUsers", //获取可以手机号登录的用户类型
  restULoginQrCodeUnionIdLoginPath: "/rest/u/loginQrCode/getLoginQrCode", // 获取小程序二维码接口
  restULoginQrCodeGetLoginQrCodeStatePath: "/rest/u/loginQrCode/getLoginQrCodeState", // 小程序二维码轮询接口
  restGetareaJsonDataPath: "/0cdn/static/front/json/areaJSON.json", // 获取地区json数据
  restUPersonalMembersInfoUpdatePath: "/rest/u/personal/members/info/update",
  restHomepageLoginConfigPath: "/common/homepage/login-config", //获取应用程序配置，包括是否显示弹窗、默认登录方式和是否隐藏扫码登录相关功能。

  // 图形验证码
  restCaptchaGetPath: "/rest/captcha/get",
  restCaptchaCheckPath: "/rest/captcha/check",
  //图形验证没有登录
  restCaptchaNoLoginCheckPath: "/rest/captcha/nologin/check",
  // 埋点
  userBehaviorInsertRecordWebsitePath: "/user/behavior/insertRecordWebsite", //公共埋点

  HTTP_CODE: {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    NO_AUTHORISE: 403,
    REDO_LOGIN: 406,
    ACCESS_CAPTCHA_PERMISSION_429: 429,
    TOO_FREQUENTLY_521: 521,
  },

  STATUS_CODE: {
    SUCCESS: 200,
    SERVER_ERR: 503,
    TO_SUBSCRIBE: 500500,
    REQUEST_CANCEL: "REQUEST_CANCEL",
    PERMISSION_EXPIRATION: 310300, // 权限过期
    ACCESS_CAPTCHA_PERMISSION_IS_MISSING: 200622, // 需要滑动验证刷新权限
  },
};
